/* globals angular, _, mintel_tracking */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.service('PptService', ['Restangular', '$alert', 'Api', '$q', '$rootScope', '$state',
    function(Restangular, $alert, Api, $q, $rootScope, $state) {
            var service = this;
            service.ppts = {};
            service.ppt_selections = {};
            service.pptPromise = $q.defer();
            service.removePPTAlert = function(type) {
                var title = 'PPT removed';
                var content = 'The ppt has been deleted.';
                if (type === 'pptItem'){
                    title = 'Item removed';
                    content = 'The item has been removed from the ppt.';
                }
                var alrt = $alert({
                                title: title,
                                content: content,
                                type: 'info',
                                container: 'body',
                                placement: 'ppt-alert',
                                dismissable: false,
                                show: false,
                                duration: 1.5
                            });
                return alrt;
            };

            service.changeName = function(ppt_id){
                var title_element = $('#' + ppt_id);
                var title = title_element.text().trim();
                var editableText = $('<textarea class="presentation-change-name" />');
                editableText.val(title);
                title_element.replaceWith(editableText);
                editableText.focus();
                editableText.blur([editableText, title, ppt_id], saveNewName);
                editableText.keydown(function(event){
                        if (event.keyCode === 13){
                            editableText.blur();
                        }
                });
            };

            var saveNewName = function (event) {
                var html = $(event.data[0]).val();
                if (html === ''){
                    html = event.data[1];
                }
                var ppt_id = event.data[2];
                var ppt_url = Restangular.one('ppt', ppt_id);
                ppt_url.get().then(function(obj) {
                ppt_url.customPUT({'name': html, 'selection': obj.selection});
                });
                var viewableText = $(
                    '<div class="presentation-name" id="'+ ppt_id +'"></div>'
                );
                viewableText.html(html);
                $(event.data[0]).replaceWith(viewableText);
                $(viewableText).click(ppt_id, service.changeName);
                mintel_tracking.engage('Sidebar', {
                    'Panel': 'My Presentations',
                    'Action': 'Rename Presentation',
                    'Presentation Title': html
                });
            };
            var updatePptsSelections = function(ppt_id, pk){
                for (var i = 0; i < service.ppt_selections[ppt_id].length; i++) {
                    if (service.ppt_selections[ppt_id][i].pk === pk){
                        service.ppt_selections[ppt_id].splice(i,1);

                    }
                }
            };
            service.removePptSelection = function(pk, ppt_id) {
                var rs = Restangular.one('pptselection', pk);
                rs.remove({'pk': pk}).then(function(){
                    var title_element = $('#' + ppt_id);
                    var title = title_element.text().trim();
                    updatePptsSelections(ppt_id, pk);
                    mintel_tracking.engage('Sidebar', {
                        'Panel': 'My Presentations',
                        'Action': 'Delete Slide from Presentation',
                        'Presentation Title': title
                    });
                });
                var alrt = service.removePPTAlert('pptItem');
                alrt.$promise.then(function() {alrt.show();});
            };

            service.removePpt = function(pk){
                var rs = Restangular.one('ppt', pk);
                rs.remove({'pk': pk}).then(function(){
                    var title_element = $('#' + pk);
                    var title = title_element.text().trim();
                    delete service.ppts[pk];
                    mintel_tracking.engage('Sidebar', {
                        'Panel': 'My Presentations',
                        'Action': 'Delete Presentation',
                        'Presentation Title': title
                    });
                });
                var alrt = service.removePPTAlert('');
                alrt.$promise.then(function() {alrt.show();});
            };

            function loadPpts(event, form) {
                var pptPromise = Api.ppt.getList();
                $q.all([pptPromise]).then(function(pr) {
                    service.ppts = {};
                    service.ppt_selections = {};
                    fillPpts(pr[0]);
                    service.pptPromise.resolve();
                    if (form && $state.current.name !== 'trendscape-item'){
                        trackingEngageContent(form);
                    }
                });
            }

            function updatePptAttrs(event, item) {
                if (item.itemTitle.length === 0) {
                    service.title = service.pageTitle;
                    service.displaydate = service.pageDisplaydate;
                    service.contentType = service.pageContentType;
                } else {
                    service.title = item.itemTitle;
                    service.displaydate = item.itemDisplaydate;
                    service.contentType = item.contentType;
                }
            }

            var trackingEngageContent = function(form) {
                angular.forEach(form.objects, function (obj) {
                    var pptId = obj.ppt_id;
                    var presentationTitle = service.ppts[pptId].name;
                    var slideCount = service.ppts[pptId].item_count;
                    mintel_tracking.engage('Content', {
                        'Title': service.title,
                        'Tags': [],
                        'Author': '',
                        'Display Date': service.displaydate,
                        'Content Type': service.contentType,
                        'Slug': '',
                        'Action': 'Add Slide to Presentation',
                        'Number of Slides': slideCount,
                        'Presentation Title': presentationTitle
                    });
                });
            };

            var fillPpts = function(ppts) {
                for (var d = 0; d < ppts.length; d++) {
                    var current_ppt = ppts[d];
                    var ppt_content = {
                        'name': current_ppt.name,
                        'items': {},
                        'pk': current_ppt.pk,
                        'item_count': current_ppt.item_count
                    };
                        for (var ds = 0; ds < current_ppt.selection.length; ds++){
                            var current_selection = current_ppt.selection[ds];
                            if(!(current_ppt.pk in service.ppt_selections)) {
                                service.ppt_selections[current_ppt.pk] = [];
                            }
                            service.ppt_selections[current_ppt.pk].push({
                                'pk': current_selection.pk,
                                'ppt_id': current_ppt.pk,
                                'sequence': current_selection.sequence,
                                'description': current_selection.description,
                                'displayed_name': current_selection.displayed_name,
                                'onhover_text': current_selection.onhover,
                                'content_changed': current_selection.content_changed,
                                'display_url': current_selection.display_url
                            });
                        }
                    ppt_content.items = service.ppt_selections[current_ppt.pk];
                    service.ppts[current_ppt.pk] = ppt_content;
                }
            };

            $rootScope.$on('reloadPpts', loadPpts);
            $rootScope.$on('$viewContentLoaded', loadPpts);  // Load when content loaded on new page
            $rootScope.$on('pptBind', updatePptAttrs);
    }]);

ngModule.directive('pptbuilder', ['Api', 'Restangular', 'PptService',
    function (Api, Restangular, PptService) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                scope.removePptSelection = function(pk, ppt_id) {
                    PptService.removePptSelection(pk, ppt_id);
                };
                scope.removePpt = function(pk){
                    var title = PptService.ppts[pk].name;
                    scope.launchValidationModal(
                        _.partial(PptService.removePpt, pk), {
                            'title': title
                        }
                    );
                };
                scope.changeName = function(ppt_id){
                    PptService.changeName(ppt_id);
                };
                scope.closePptbuilderDropdown = function(e) {
                    if(!$.contains($('.pptbuilder-dropdown')[0],e.relatedTarget)) {
                        scope.dropdown.hide();
                    }
                };
                scope.pptLength = function(pk){
                    var currentPptItems = PptService.ppts[pk].items;
                    if (currentPptItems !== undefined) {
                        return currentPptItems.length;
                    } else {
                        return 0;
                    }
                };
                /* return 1 if the content has changed (stats), 2 if the content has been unpublished */
                scope.pptSelectionContentStatus = function(ppt_id, selection_id) {
                    var selection = PptService.ppts[ppt_id];
                    if (selection) {
                        for (var i = 0; i < selection.items.length; i++) {
                            if (selection.items[i].content_changed &&
                                selection.items[i].pk === selection_id) {
                                return selection.items[i].content_changed;
                            }
                        }
                    }
                    return false;
                };
                scope.getStyle = function(selection_id, ppt_id){
                    if (scope.pptSelectionContentStatus(ppt_id, selection_id)) {
                        return {'font-style': 'italic'};
                    } else {
                        return {'font-style': 'normal'};
                    }
                };
                scope.popoverPptSelectionLimitContent = '<html><b>Warning!</b><br> Please review this item. ' +
                    'The content has been updated since it was added to this presentation.</html>';
                scope.popoverPptSelectionContentUnpublished = '<html><b>Warning!</b><br> The content on this slide ' +
                    'has been unpublished. This slide will not be included in your deck.</html>';
                scope.anyExistingPpts = function() {
                    if (PptService.ppts && !(_.isEmpty(PptService.ppts))) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                scope.addIconToItem = function (item) {
                    alert(item);
                };
                scope.$emit('reloadPpts');
                scope.$watch(function() {
                    return PptService.ppts;
                }, function () {
                    scope.ppts = PptService.ppts;
                });
            }
        };
}]);

ngModule.directive('addIconToItem',
    function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var iconsMatch = {
                    'overview': 'PD-magnifyingGlass',
                    'statistic': 'PD-analysis',
                    'history': 'PD-history',
                    'trend-cover': 'PD-trends',
                    'observation-cover': 'PD-observations',
                    'report-section': 'PD-reports',
                    'implication': 'PD-implications',
                    'key-actions': 'PD-key-action-items',
                    'wiif': 'PD-what-it-means',
                    'hvt-summary': 'PD-category',
                    'regional-context': 'PD-regional',
                    'heatmap': 'PD-globe',
                    'trendscape': 'PD-trendscape'
                };
                var item = scope.$eval(attrs.addIconToItem);
                angular.forEach(iconsMatch, function(value, key) {
                    if(item.description.indexOf(key) === 0) {
                        element.addClass(value);
                    }
                });
            }
        };
});

ngModule.directive('pptPreview', ['Api', 'AjaxList', 'PptService',
    function (Api, AjaxList, PptService) {
        return {
            restrict: 'A',
            link: function (scope) {
                if (!_.isEmpty(scope.ppts) && scope.ppt_id !== undefined){
                    scope.selectedPpt = scope.ppts[scope.ppt_id];
                }
                scope.removePptSelection = function(pk, ppt_id) {
                    PptService.removePptSelection(pk, ppt_id);
                    for (var i = 0; i < scope.content.items.length; i++){
                        if (scope.content.items[i].ppt_section_id === pk){
                            scope.content.items.splice(i, 1);
                            scope.content.maxItems -= 1;
                            i--;
                        }
                    }
                    scope.setPosition(0);
                    if (scope.content.maxItems === 0){
                        scope.$hide();
                    }
                };
                scope.$watch(function() {
                    return scope.selectedPpt;
                }, function (newvalue, oldvalue) {
                    if (newvalue !== undefined && newvalue !== '' && newvalue !== oldvalue){
                        scope.content.reset();
                        scope.content = new AjaxList(
                            Api.content.ppt_preview,
                            {defaultParams: {'ppt_id': scope.selectedPpt.pk}}
                        );
                        scope.content.loadNext().then(function(){
                            scope.$emit('dataSourceChanged');
                       });
                    }
                    }
                );

                scope.$watch(function() {
                    return scope.content.lastLoadErrored();
                }, function() {
                    if (scope.content.error !== '') {
                        var data = {
                            'errorMessage': scope.content.error
                        };
                        scope.$emit('modal.setstate', 'error', data);
                    }
                });
            }
        };

}]);
